import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { AuthProvider } from "./use-auth";

// Routes (or route prefixes) that require the auth context to be live.
// Everything else falls back to the default context (user=null, loading=false).
const AUTH_ROUTE_PREFIXES = [
  "/portal",
  "/admin",
  "/partners",
  "/get-quote",
  "/book-service",
  "/ev-chargers",
  "/roofing-calculator",
];

const needsAuth = (pathname: string) =>
  AUTH_ROUTE_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));

export const RouteAwareAuthProvider = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();

  if (!needsAuth(pathname)) {
    return <>{children}</>;
  }

  return <AuthProvider>{children}</AuthProvider>;
};
